export enum SourceCheckOutcome {
  RESULTS = "results",
  NO_RESULTS = "no_results",
  // Validated Source Records were retained while required capture work stayed
  // unfinished. Never a completed search, and never a Negative Search Result.
  PARTIAL = "partial",
  BLOCKED = "blocked",
  FAILED = "failed",
}

// The outcomes of a search that finished: a Task they answer is Stale once
// its freshness window lapses, and any other outcome makes it a Retry.
export const completedSearchOutcomes = [
  SourceCheckOutcome.RESULTS,
  SourceCheckOutcome.NO_RESULTS,
]

export const dataBySourceCheckOutcome: Record<
  SourceCheckOutcome,
  { label: string }
> = {
  [SourceCheckOutcome.RESULTS]: { label: "Records found" },
  [SourceCheckOutcome.NO_RESULTS]: { label: "No records found" },
  [SourceCheckOutcome.PARTIAL]: { label: "Partial" },
  [SourceCheckOutcome.BLOCKED]: { label: "Blocked" },
  [SourceCheckOutcome.FAILED]: { label: "Failed" },
}
